import axios from "axios";
import { API_URL, API_URL_ANGULAR } from "../utils/Constant";
import { getUser } from "../utils/helpers";

const isAbortedRequest = (error) => error?.code === "ERR_CANCELED";

/**
 * Fetch users list for downdown
 */
export const getUserList = async (payload = {}, signal = null) => {
  try {
    const params = {
      is_active: true,
      page: 1,
      page_size: 5000,
      search: "",
      ...payload,
    };
    const response = await axios.get(`${API_URL_ANGULAR}/users/`, { params, signal });
    const data = response.data;
    return { success: true, ...data };
  } catch (e) {
    if (isAbortedRequest(e)) {
      return { success: false, canceled: true };
    }
    return { success: false, message: "Failed to load company names for search." };
  }
};

/**
 * Fetch all generted session history list
 * @param {{user_filter: number, start_date: Date, end_date: Date}} payload payload
 * @param {AbortSignal} [signal=null]
 */
export const getMLAnalyticsSessionHistory = async (payload, signal = null) => {
  try {
    const params = {
      user_filter: payload.user_filter,
      start_date: payload.start_date,
      end_date: payload.end_date,
    };
    const response = await axios.get(`${API_URL}/ml_analytics_session_history/`, { params, signal });
    const data = response.data;
    return { success: true, data };
  } catch (e) {
    if (isAbortedRequest(e)) {
      return { success: false, canceled: true };
    }
    return { success: false, message: "Something went wrong!" };
  }
};

/**
 * Get single session data with details
 * @param {string} session_id session id
 * @param {AbortSignal} [signal=null]
 */
export const getMLAnalyticsSession = async (session_id, signal = null) => {
  try {
    const params = { session_id };
    const response = await axios.get(`${API_URL}/ml_analytics_session_history/`, { params, signal });
    const data = response.data;
    return { success: true, ...data };
  } catch (e) {
    if (isAbortedRequest(e)) {
      return { success: false, canceled: true };
    }
    return { success: false, message: "Something went wrong!" };
  }
};

/**
 * Generate a new session using the session id and a new prompt
 * @param {string} session_id session id
 * @param {string} prompt user prompt
 * @param {AbortSignal} [signal=null]
 */
export const mlAnalyticsGenerate = async (session_id, prompt, signal = null) => {
  try {
    const user = getUser();
    const body = {
      prompt,
      user_id: user.id,
      session_id,
      user_name: user.username,
    };
    const response = await axios.post(`${API_URL}/ml_analytics_generate/`, body, { signal });
    const data = response.data;
    return { success: true, ...data };
  } catch (e) {
    if (isAbortedRequest(e)) {
      return { success: false, canceled: true };
    }
    const data = e?.response?.data;
    if (data?.error_type || data?.error_message) {
      return { success: false, ...data };
    }
    return {
      success: false,
      error_type: "UNKNOWN_ERROR",
      error_message: "Something went wrong!",
    };
  }
};
